import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ITile } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import AGENT_HOME from "../../../utils/constants/agentHome";
import CustomTiles from "../../shared/CustomTiles";

import styles from "./index.module.scss";

function AgentHome() {
  const { t } = useTranslation();

  const { name } = useTypedSelector((state) => state.session);

  const { welcome_title, agent_home_tiles } = useTypedSelector(
    (state) => state.environment,
  );

  const parsedTiles: ITile[] = useMemo(() => {
    const parsed = JSON.parse(agent_home_tiles);

    if (Array.isArray(parsed)) {
      return parsed.map((tile: any) => ({
        ...tile,
        target: "_blank" as const,
      }));
    }

    return [];
  }, [agent_home_tiles]);

  const allTiles: ITile[] = useMemo(() => {
    return [...AGENT_HOME.TILES, ...parsedTiles];
  }, [parsedTiles]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.greetingContainer}>
          <h1 className={styles.title}>{`${t("hello")} ${name}`}</h1>
          <p className={styles.subTitle}>{welcome_title}</p>
        </div>

        <CustomTiles tiles={allTiles} />
      </div>
    </div>
  );
}

export default AgentHome;
